import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { config } from '../../config';
import { markAsTouched } from '../shared/utils';
import { emailValidator, requiredValidator } from '../shared/validators';
import { finalize } from 'rxjs/operators';

@Component({
  templateUrl: './contact.component.html',
})
export class ContactComponent {
  form = new FormGroup({
    type: new FormControl('client', requiredValidator()),
    name: new FormControl(null, requiredValidator()),
    email: new FormControl(null, [
      requiredValidator(),
      emailValidator(),
    ]),
    phone: new FormControl(),
    message: new FormControl(null, requiredValidator()),
  });
  pending = false;
  sent = false;

  constructor(private http: HttpClient) {}

  submit() {
    if (this.form.valid || this.pending) {
      this.pending = true;
      this.sent = false;

      this.http
        .post<void>(`${config.apiLocation}/utils/contact`, this.form.value)
        .pipe(finalize(() => this.pending = false))
        .subscribe(() => this.sent = true);
    } else {
      markAsTouched(this.form);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/marketing/contact.component.ts